// Slug derivation shared by the client (Plan form auto-suggest) and kept
// in step with the server's rollout slugify
// (server/modules/rollouts/internal.ts#slugify): lowercase, strip
// diacritics, collapse every non-alphanumeric run to a single dash, trim
// leading/trailing dashes. The Plan's rolloutSlug is only a suggestion the
// AM can override; the server re-derives via its own slugify when the Plan
// leaves it null, so keeping the algorithm identical keeps both paths
// predictable.
//
// "May 2026 - Get Started for $1" -> "may-2026-get-started-for-1"
const COMBINING_MARKS = /[̀-ͯ]/g;

export function slugify(name: string): string {
  return name
    .toLowerCase()
    .normalize('NFKD')
    .replace(COMBINING_MARKS, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}
